module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticClass: "padded",
    attrs: {
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h3', [_c('i', {
    staticClass: "fa fa-cog"
  }, [_vm._v(" ")]), _c('org-badge'), _vm._v(" Settings")], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-menu', {
    attrs: {
      "collapse": true,
      "background-color": "#F2F6FC"
    },
    on: {
      "select": _vm.show
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('el-menu-item-group', {
    attrs: {
      "title": "Organisations"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "Organisations",
      "effect": "light",
      "placement": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-th-large text-muted"
  })])], 1), _vm._v(" "), (_vm.isManager()) ? _c('el-menu-item', {
    attrs: {
      "index": "orgs-xolas"
    }
  }, [_c('i', {
    staticClass: "fa fa-star"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.ellipsis(_vm.clientName, 15)))])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('project|maintenance|finance|management')) ? _c('el-menu-item', {
    attrs: {
      "index": "orgs-telco"
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Telcos")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('project|maintenance|finance|management')) ? _c('el-menu-item', {
    attrs: {
      "index": "orgs-contractor"
    }
  }, [_c('i', {
    staticClass: "fa fa-tools"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Contractors")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('project|maintenance|finance|management')) ? _c('el-menu-item', {
    attrs: {
      "index": "orgs-backhaul"
    }
  }, [_c('i', {
    staticClass: "fa fa-wifi"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Backhaul Providers")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('property|finance|management')) ? _c('el-menu-item', {
    attrs: {
      "index": "orgs-landlord"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Landlords")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('admin|property|finance|management')) ? _c('el-menu-item', {
    attrs: {
      "index": "orgs-insurer"
    }
  }, [_c('i', {
    staticClass: "fa fa-shield-alt"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Insurers")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('admin|property|finance|management')) ? _c('el-menu-item', {
    attrs: {
      "index": "orgs-utility"
    }
  }, [_c('i', {
    staticClass: "fa fa-plug"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Utilities")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('admin|property|finance|management')) ? _c('el-menu-item', {
    attrs: {
      "index": "orgs-authority"
    }
  }, [_c('i', {
    staticClass: "fa fa-university"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Authorities")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('project|maintenance|finance|management')) ? _c('el-menu-item', {
    attrs: {
      "index": "orgs-tower-supplier"
    }
  }, [_c('i', {
    staticClass: "fa fa-tower-cell"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Tower Suppliers")])]) : _vm._e()], 2), _vm._v(" "), (_vm.isManager()) ? _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "System",
      "effect": "light",
      "placement": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks text-muted"
  })])], 1), _vm._v(" "), (_vm.isManager('project|maintenance|admin')) ? _c('el-menu-item', {
    attrs: {
      "index": "workflow"
    }
  }, [_c('i', {
    staticClass: "fa fa-cogs"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Master Workflows")])]) : _vm._e(), _vm._v(" "), (_vm.isSuper()) ? _c('el-menu-item', {
    attrs: {
      "index": "cats"
    }
  }, [_c('i', {
    staticClass: "fa fa-tags"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Categories")])]) : _vm._e(), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "loc"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-pin"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Localities")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "struct"
    }
  }, [_c('i', {
    staticClass: "fa fa-broadcast-tower"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Structures")])])], 2) : _vm._e(), _vm._v(" "), (_vm.isManager()) ? _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "Other Settings",
      "effect": "light",
      "placement": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-random text-muted"
  }, [_vm._v(" ")])])], 1), _vm._v(" "), (_vm.isManager('finance|management|admin')) ? _c('el-menu-item', {
    attrs: {
      "index": "finance"
    }
  }, [_c('i', {
    staticClass: "fa fa-dollar-sign"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Finance")])]) : _vm._e(), _vm._v(" "), (_vm.isManager()) ? _c('el-menu-item', {
    attrs: {
      "index": "backup"
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Backup Data")])]) : _vm._e(), _vm._v(" "), (_vm.isManager()) ? _c('el-menu-item', {
    attrs: {
      "index": "logs"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("System Users")])]) : _vm._e()], 2) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', [_c(_vm.comp, _vm._b({
    tag: "component"
  }, 'component', _vm.defaultProps, false))], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25b91cef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/SettingsView.vue
// module id = 1376
// module chunks = 0